import bact from '@/sui/data/sheets/edit/bact'
import intub from '@/sui/data/sheets/edit/intub'
import pneu from '@/sui/data/sheets/edit/pneu'
import bounds from '@/sui/data/sheets/edit/bounds'
import patient from '@/sui/data/sheets/edit/patient'
import notes from '@/sui/data/sheets/edit/notes'
import fields from '@/sui/data/sheets/edit/fields'

import common from '@/sui/data/sheets/edit/notes/common'

function checkNumericValues (result, sheet) {
  const numericChecks = [
    bounds.gestationalAge,
    bounds.birthWeight,
    bounds.igsII,
    bounds.pimII,
    bounds.cribII
  ]

  notes.checkNumerics(result, sheet, numericChecks)
}

function checkInfections (result, sheet) {
  const type = sheet[fields.unitType]
  const neoPedMix = type != null && type.match(/^(NEO|MIX|PED)/) != null
  const expm = sheet[fields.expManagment]
  switch (expm) {
    case 1:
      common.checkBactOrigin(result, sheet, neoPedMix)
      break

    case 2:
      {
        common.checkInfOrigin(
          result, sheet, pneu.pneuFields.pneu.origin, 'La pneumopathie', neoPedMix
        )
        const field = pneu.pneuFields.pneu.diagnosis
        const diagnosis = sheet[field]
        if (diagnosis != null && diagnosis !== 5) {
          common.checkMicroOrg(
            result, sheet, field, 'Une pneumopathie', null,
            pneu.pneuFields.pneu.microOrg
          )
        }
      }
      break

    case 3:
      common.checkInfOrigin(
        result, sheet, bact.sepFields.v1.origin, 'Le sepsis', neoPedMix
      )
      break
  }
}

function checkDates (result, sheet, year) {
  const y = `${year}`
  const oldest = notes.oldest[y]
  const newest = notes.newest[y]
  const start = notes.start[y]
  const birthdate = notes.dateField(result, sheet, patient.birthdate)
  const entrydate = notes.dateField(result, sheet, patient.entrydate)
  const death = notes.dateField(result, sheet, patient.deathDate)

  const comparisons = [
    { f: oldest, s: birthdate },

    { f: birthdate, s: newest },
    { f: entrydate, s: newest },
    { f: death, s: newest },

    { f: birthdate, s: entrydate },
    { f: birthdate, s: death },

    { f: entrydate, s: death }
  ]

  if (sheet[fields.expManagment] === 3) {
    comparisons.push({
      f: notes.neoOldest[y], s: birthdate
    })
  }

  const v = year === 2020 ? 'v1' : 'v2'
  const obj = [
    { t: bact, f: f => f.base, m: true },
    { t: bact.sepFields[v], f: f => f }
  ]
  obj.forEach(
    o => {
      const episod = notes.dateField(result, sheet, o.t.episod)
      if (year >= 2025) {
        common.checkEpisodAndEntry(episod, entrydate)
      }
      const insertionDate = notes.dateField(
        result, sheet, o.f(o.t.insertionDate)
      )
      const enfInsertionDate = notes.dateField(
        result, sheet, o.f(o.t.enfInsertionDate)
      )
      const removalDate = notes.dateField(result, sheet, o.f(o.t.removalDate))
      const diagdate = notes.dateField(result, sheet, o.f(o.t.diagDate))
      const urinaryStart = notes.dateField(result, sheet, o.f(o.t.urinaryStart))
      const urinaryEnd = notes.dateField(result, sheet, o.f(o.t.urinaryEnd))
      const intubStart = notes.dateField(result, sheet, o.t.intubStart)
      comparisons.push(
        { f: start, s: episod },
        { f: episod, s: newest },
        { f: insertionDate, s: newest },
        { f: enfInsertionDate, s: newest },
        { f: removalDate, s: newest },

        { f: birthdate, s: episod },
        { f: birthdate, s: insertionDate },
        { f: birthdate, s: enfInsertionDate },
        { f: birthdate, s: removalDate },

        { f: episod, s: death },
        { f: episod, s: diagdate },
        { f: birthdate, s: diagdate },

        { f: insertionDate, s: episod },
        { f: insertionDate, s: removalDate },
        { f: insertionDate, s: death },

        { f: enfInsertionDate, s: episod },
        { f: enfInsertionDate, s: removalDate },
        { f: enfInsertionDate, s: death },

        { f: removalDate, s: death },

        { f: birthdate, s: urinaryStart },
        { f: birthdate, s: urinaryEnd },

        { f: urinaryStart, s: episod },
        { f: urinaryStart, s: newest },
        { f: urinaryEnd, s: newest },

        { f: urinaryStart, s: death },
        { f: urinaryEnd, s: death },
        { f: urinaryStart, s: urinaryEnd },

        { f: intubStart, s: death },
        { f: birthdate, s: intubStart },
        { f: intubStart, s: episod }
      )

      if (year >= 2021) {
        const intubEnd = notes.dateField(result, sheet, o.t.intubEnd)
        comparisons.push(
          { f: intubStart, s: intubEnd },
          { f: intubEnd, s: death },
          { f: birthdate, s: intubEnd }
        )
      }

      if (year >= 2021 && o.m) {
        const manipdate = notes.dateField(
          result, sheet, o.t.previousManipDate
        )
        const enfmanipdate = notes.dateField(
          result, sheet, bact.enfPreviousManipDate
        )
        const beforeEpisod = common.beforeEpisod(
          episod.date, result[bact.episod.field]
        )

        comparisons.push(
          { f: birthdate, s: manipdate },
          { f: beforeEpisod, s: manipdate },
          { f: manipdate, s: episod },
          { f: insertionDate, s: manipdate },
          { f: manipdate, s: removalDate },
          { f: manipdate, s: death },

          { f: birthdate, s: enfmanipdate },
          { f: beforeEpisod, s: enfmanipdate },
          { f: enfmanipdate, s: episod },
          { f: enfInsertionDate, s: enfmanipdate },
          { f: enfmanipdate, s: death }
        )
      }
    }
  )

  {
    const episod = notes.dateField(result, sheet, pneu.episod.pneu)
    if (year >= 2025) {
      common.checkEpisodAndEntry(episod, entrydate)
    }

    const diagdate = notes.dateField(result, sheet, pneu.diagDate.pneu)
    const intubStart = notes.dateField(result, sheet, intub.intubStart.std)
    const intubEnd = notes.dateField(result, sheet, intub.intubEnd.std)
    comparisons.push(
      { f: start, s: episod },
      { f: episod, s: newest },
      { f: birthdate, s: episod },
      { f: episod, s: death },
      { f: episod, s: diagdate },
      { f: birthdate, s: diagdate },
      { f: birthdate, s: intubStart },
      { f: intubStart, s: death },
      { f: intubStart, s: intubEnd },
      { f: birthdate, s: intubEnd },
      { f: intubEnd, s: death }
    )
  }
  notes.compareDates(comparisons)
}

function buildNotes (result, sheet, year, surveillance, explaur) {
  checkDates(result, sheet, year)
  common.checkPatientOrigin(result, sheet, year)
  checkInfections(result, sheet)
  checkNumericValues(result, sheet)
  common.checkBactMicroOrg(result, sheet, fields.episod, explaur)
  common.checkPortageMO(result, sheet)
  common.checkUfs(result, sheet, 'expADI', surveillance)
}

export default {
  build2026: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2026, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    return result
  },

  build2025: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2025, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    return result
  },

  build2024: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2024, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    return result
  },

  build2023: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2023, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    return result
  },

  build2022: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2022, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    return result
  },

  build2021: function (result, sheet, surveillance) {
    buildNotes(
      result, sheet, 2021, surveillance,
      common.getExplaurUnit(sheet, surveillance)
    )
    return result
  },

  build2020: function (result, sheet, surveillance) {
    buildNotes(result, sheet, 2020, surveillance)
    return result
  }
}
